export default __webpack_public_path__ + "static/christmas-movies-5e91fcc8bdba64da953a09684bce455f.gif";